export class BooleanUtil {
  public static parse(value: string) {
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }

    return null;
  }
}
